module.exports = __webpack_public_path__ + "static/media/chef-hat.10fc66aa.svg";